<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Special offers storage</h1>
            <h4 class="subtitle">Manage the storage for your special offer menus here.</h4>
          </div>
        </div>
      </div>

<div class="columns is-multiline is-mobile">
        <div class="column is-9 is-offset-1 box" border-color="black">
          <div><b>Special offers storage size: </b>{{!totalOffersSize ? (totalOffersSize === 0 ? formatBytes(totalOffersSize, 2) : 'Calculating...') : formatBytes(totalOffersSize, 2)}}</div>
                              <b-progress
            :rounded=0
            :value="offersPercent"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>

        <div><b>Total storage used: </b>{{!totalStorageSize ? (totalStorageSize === 0 ? formatBytes(totalStorageSize, 2) : 'Calculating...') : formatBytes(totalStorageSize, 2) + '/1 GB'}}</div>
                              <b-progress
            :rounded="false"
            :value="totalPercentUsed"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress>
        <!-- <div><b>Total storage free: </b>{{formatBytes(freeStorageSize, 2)}}/1 GB</div>
<b-progress
            :rounded="false"
            :value="totalPercentFree"
            type="is-primary"
            format="percent"
            show-value
        ></b-progress> -->
          </div>
                  <div></div>
</div>
      <div class="columns is-multiline is-mobile">
        <div class="column is-4 is-offset-1 box" border-color="black" v-for="(menu, menuId) in specialOffers" :key="menuId">
          <div class="level" >
            <div class="level-left">
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>{{showName(menu.name)}}</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="menu.items && menu.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined).length > 0">
                <b-button type="is-primary is-light" @click="seeResources(menuId, menu.name)">See resources</b-button>
              </div>
              </div>
          </div>

            <p><b>No. of resources:</b> {{numOffRes[menuId] !== undefined ? numOffRes[menuId] : 'Calculating...'}}</p>
            <p><b>Total size:</b> {{totalSizes.find(x => x.key === menuId) !== undefined ? formatBytes(totalSizes.find(x => x.key === menuId).value, 2) : 'Calculating...'}}</p>
        </div>
        <div></div>

               <div class="column is-4 is-offset-1 box" border-color="black">
          <div class="level" >
            <div class="level-left">
              <b-button type="is-ghost" icon-left="trash" style="cursor:auto"></b-button>
              <div style="font-size:17.5px;color:#3e8ed0" class="level-item"><b>Special offers archive</b></div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="shouldSeeResources">
                <b-button type="is-primary" @click="seeArchivedResources()">See resources</b-button>
              </div>
              <div class="level-item" v-else>
                <b-button type="is-primary" @click="seeArchivedResources()" disabled>See resources</b-button>
              </div>
              </div>
          </div>

            <p><b>No. of resources:</b> {{!noArchived ? (noArchived === 0 ? noArchived : 'Calculating...') : noArchived}}</p>
            <p><b>Total size:</b> {{!totalSizeArchived ? (totalSizeArchived === 0 ? formatBytes(totalSizeArchived, 2) : 'Calculating...') : formatBytes(totalSizeArchived, 2)}}</p>
        </div>
        <div></div>
      </div>

    </div>
  </section>
</template>

<script>
import OffersResources from '@/components/storage/offers/OffersResources.vue'
import OffersArchive from '@/components/storage/offers/OffersArchive'

export default {
  name: 'OffersStorage',
  data: () => {
    return {
      noArchived: null,
      totalSizeArchived: null,
      totalSizes: [],
      totalOffersSize: null,
      totalStorageSize: null,
      // freeStorageSize: null,
      totalPercentUsed: null,
      // totalPercentFree: null,
      offersPercent: null,
      shouldSeeResources: false,
      numOffRes: []
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    playlistsArchive () {
      return this.$store.state.playlistsArchive
    },
    menusArchive () {
      return this.$store.state.menusArchive
    }
    /* specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    } */
  },
  mounted: function () {
    this.loadArchiveData()
  },
  methods: {
    seeResources (id, name) {
      this.$buefy.modal.open({
        parent: this,
        component: OffersResources,
        props: { menuId: id, menuName: name },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd
      })
    },
    seeArchivedResources () {
      const modal = this.$buefy.modal.open({
        parent: this,
        component: OffersArchive,
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
      modal.$on('close', () => {
        this.showStorageData()
      })
    },
    /* refreshData () {
      console.log('refreshData')
      // this.loadingComponent = this.$buefy.loading.open()
      var counter = 0
      var totalSize = 0
      var playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/')
      playlistDirsRef.listAll().then((dir) => {
        dir.items.forEach(fileRef => {
          counter++
          this.noArchived = counter
          fileRef.getDownloadURL().then((url) => {
            const xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = (event) => {
              const blob = xhr.response
              totalSize += blob.size
              this.totalSizeArchived = totalSize
            }
            xhr.open('GET', url)
            xhr.send()
          }).catch((error) => {
            console.log('error', error)
          })
          // this.loadingComponent.close()
        })
      })
    }, */
    formatBytes (bytes, decimals) {
      if (bytes === 0) {
        return '0 B'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    loadArchiveData () {
      let database = this.$store.state.database
      let store = this.$store
      if (!this.getNotMigrated().includes(store.state.uid)) {
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/neoslide/archive/' + store.state.workspaceId + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      } else {
        database.ref('/archive/' + store.state.uid + '/menus/').on('value', (snapshot) => {
          store.commit('setMenusArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/playlists/').on('value', (snapshot) => {
          store.commit('setPlaylistsArchive', snapshot.val())
        })
        database.ref('/archive/' + store.state.uid + '/specialOffers/').on('value', (snapshot) => {
          store.commit('setSpecialOffersArchive', snapshot.val())
          this.showStorageData()
        })
      }
    },
    showStorageData () {
      var specialOffersArchive = this.$store.state.specialOffersArchive
      this.totalSizes = []
      this.totalStorageSize = 0
      this.totalSizeArchived = 0
      this.totalOffersSize = 0
      this.noArchived = 0
      for (let offer in this.specialOffers) {
        var sum = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          // console.log('menu items unfiltered: ', offerItems)
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          // console.log('menu items filtered: ', offerItems)
          var noResources = offerItems.length
          this.numOffRes[offer] = noResources
          if (noResources > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum += offerItems[i].resourceSize
              }
            }
            this.totalSizes.push({ 'key': offer, 'value': sum })
            this.totalStorageSize += sum
          }
        } else {
          this.numOffRes[offer] = 0
          this.totalSizes.push({ 'key': offer, 'value': 0 })
        }
      }
      if (this.totalSizes.length > 0) {
        for (let j = 0; j < this.totalSizes.length; j++) {
          this.totalOffersSize += this.totalSizes[j].value
        }
      }
      // archive begin
      if (specialOffersArchive !== null) {
        // specialOffersArchive = this.$store.state.specialOffersArchive
        for (let i = 0; i < specialOffersArchive.items.length; i++) {
          this.totalStorageSize += specialOffersArchive.items[i].resSize
          this.totalOffersSize += specialOffersArchive.items[i].resSize
          this.totalSizeArchived += specialOffersArchive.items[i].resSize
          this.noArchived++
        }
      }
      if (this.noArchived > 0) {
        this.shouldSeeResources = true
      } else {
        this.shouldSeeResources = false
      }
      if (this.playlistsArchive !== null) {
        for (let x = 0; x < this.playlistsArchive.items.length; x++) {
          this.totalStorageSize += this.playlistsArchive.items[x].resSize
        }
      }
      if (this.menusArchive !== null) {
        for (let y = 0; y < this.menusArchive.items.length; y++) {
          this.totalStorageSize += this.menusArchive.items[y].resSize
        }
      }
      // archive end
      this.offersPercent = (this.totalOffersSize / 1073741824) * 100
      for (let playlist in this.playlists) {
        var sum1 = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = playlistItems.length
          if (noResources1 > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum1 += playlistItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let menu in this.menus) {
        var sum2 = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '' && x.resourceName !== undefined)]
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = menuItems.length
          if (noResources2 > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum2 += menuItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      // this.freeStorageSize = 1073741824 - this.totalStorageSize
      this.totalPercentUsed = (this.totalStorageSize / 1073741824) * 100
      // this.totalPercentFree = (this.freeStorageSize / 1073741824) * 100
    },
    showName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/storage/offers/OffersStorage.vue